import React from 'react';
import { useParams } from 'react-router-dom';
import { Row, Spinner } from 'react-bootstrap';
import { useQuery } from '@tanstack/react-query';
import { getUrlIframeBusinessIntelligence } from '@lib/api';

const BusinessIntelligence = () => {
	const { projectId } = useParams();

	const {
		data: urlIframe,
		isPending: isPendingUrl,
		isError: isErrorUrl,
	} = useQuery({
		queryKey: ['urlIframe', projectId],
		queryFn: async () => {
			const response = await getUrlIframeBusinessIntelligence(projectId);
			if (response.success) {
				return response.data.embedUrl;
			} else {
				return null;
			}
		},
		enabled: !!projectId,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
	});

	if (!projectId) return null;

	return (
		<>
			<Row className="justify-content-center">
				{isPendingUrl && <Spinner animation="border" className="my-3" />}
				{isErrorUrl && <div>Errore nel caricamento del report.</div>}
				   {urlIframe && (
					   <iframe
						   src={urlIframe}
						   title="Business Intelligence"
						   style={{
							   width: '100vw',
							   height: '80vh',
							   border: 'none',
							   display: 'block',
							   maxWidth: '100%',
							   padding: 0,
						   }}
						   allowFullScreen
					   />
				   )}
			</Row>
		</>
	);
};
export default BusinessIntelligence;
